// client/src/components/Admin/Dashboard/_shared/GlobalsDonut.js
//
// M06 Fase 5 - Donut con la distribucion global de roles. Reemplaza al
// RolesDonut legacy. Acepta el array `roles` extendido con segmentos M06
// (terapeutas, pacientes, otros).

import React from "react";
import { Pie } from "@ant-design/charts";
import styles from "./GlobalsDonut.module.scss";

const COLOR_PALETTE = [
  "#2b323f", // azul-button
  "#1d4aed", // grad-start
  "#245e55", // tea
  "#ed773c", // tangerine
  "#c63f3e", // red-passion
  "#7c3aed", // violeta
  "#0ea5e9", // celeste
  "#9ca3af", // gris (otros)
];

export function GlobalsDonut({ roles = [], height = 320 }) {
  const data = (roles || [])
    .filter((r) => Number(r?.count ?? 0) > 0)
    .map((r) => ({
      type: r.label || r.key,
      value: Number(r.count ?? 0),
    }));

  if (data.length === 0) {
    return (
      <div className={styles.globalsDonut}>
        <div className={styles.empty}>Sin datos</div>
      </div>
    );
  }

  const total = data.reduce((acc, d) => acc + d.value, 0);

  const config = {
    data,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.64,
    label: false,
    legend: { position: "right" },
    color: COLOR_PALETTE,
    statistic: {
      title: false,
      content: { content: `Total ${total}`, style: { fontSize: 14 } },
    },
    height,
  };

  return (
    <div className={styles.globalsDonut}>
      <Pie {...config} />
    </div>
  );
}
